import { SEO } from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Politique de Confidentialité - Château de Clémentine"
        description="Politique de confidentialité et protection des données personnelles pour la location de châteaux gonflables et sumos."
        canonicalUrl="https://chateaudeclementine.com/privacy-policy"
      />
      
      {/* Header */}
      <div className="bg-gradient-sky py-16">
        <div className="container mx-auto px-4">
          <Link to="/">
            <Button variant="ghost" className="mb-6">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour à l'accueil
            </Button>
          </Link>
          <h1 className="text-4xl md:text-5xl font-display font-bold text-foreground">
            Politique de Confidentialité
          </h1>
          <p className="text-xl text-muted-foreground mt-4">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto prose prose-lg">
          
          <h2>1. Collecte des données personnelles</h2>
          <p>
            Château de Clémentine collecte les données personnelles suivantes :
          </p>
          <ul>
            <li>Nom et prénom</li>
            <li>Adresse email</li>
            <li>Numéro de téléphone</li>
            <li>Adresse de l'événement</li>
            <li>Informations sur l'événement (date, type, nombre d'enfants)</li>
          </ul>

          <h2>2. Finalités du traitement</h2>
          <p>Vos données personnelles sont traitées pour :</p>
          <ul>
            <li>Traiter vos demandes de réservation</li>
            <li>Vous contacter concernant votre réservation</li>
            <li>Améliorer nos services</li>
            <li>Respecter nos obligations légales</li>
          </ul>

          <h2>3. Base légale</h2>
          <p>
            Le traitement de vos données repose sur :
          </p>
          <ul>
            <li>Votre consentement (article 6.1.a du RGPD)</li>
            <li>L'exécution d'un contrat (article 6.1.b du RGPD)</li>
            <li>L'intérêt légitime (article 6.1.f du RGPD)</li>
          </ul>

          <h2>4. Partage des données</h2>
          <p>
            Vos données peuvent être partagées avec :
          </p>
          <ul>
            <li>Nos prestataires de services (hébergement, email)</li>
            <li>Les autorités compétentes si requis par la loi</li>
          </ul>
          <p>
            Nous ne vendons jamais vos données personnelles à des tiers.
          </p>

          <h2>5. Cookies et technologies similaires</h2>
          <p>
            Notre site utilise des cookies pour :
          </p>
          <ul>
            <li>Mesurer l'audience avec Google Analytics</li>
            <li>Diffuser des publicités pertinentes avec Google Ads</li>
            <li>Améliorer l'expérience utilisateur</li>
          </ul>
          <p>
            Les cookies tiers utilisés incluent :
          </p>
          <ul>
            <li><strong>Google Analytics :</strong> Analyse d'audience</li>
            <li><strong>Google Ads :</strong> Publicité ciblée</li>
            <li><strong>Google AdSense :</strong> Diffusion de publicités</li>
          </ul>

          <h2>6. Transferts internationaux</h2>
          <p>
            Vos données peuvent être transférées vers des pays tiers dans le cadre de l'utilisation de services Google (États-Unis). 
            Ces transferts sont encadrés par les clauses contractuelles types de la Commission européenne.
          </p>

          <h2>7. Durée de conservation</h2>
          <p>
            Nous conservons vos données personnelles :
          </p>
          <ul>
            <li>3 ans pour les données de contact et réservation</li>
            <li>13 mois pour les cookies Google Analytics</li>
            <li>Jusqu'à retrait du consentement pour les cookies publicitaires</li>
          </ul>

          <h2>8. Vos droits</h2>
          <p>
            Conformément au RGPD, vous disposez des droits suivants :
          </p>
          <ul>
            <li>Droit d'accès à vos données</li>
            <li>Droit de rectification</li>
            <li>Droit à l'effacement</li>
            <li>Droit à la limitation du traitement</li>
            <li>Droit à la portabilité</li>
            <li>Droit d'opposition</li>
            <li>Droit de retirer votre consentement</li>
          </ul>
          <p>
            Pour exercer ces droits, contactez-nous à : lechateaudeclementine@gmail.com
          </p>

          <h2>9. Sécurité des données</h2>
          <p>
            Nous mettons en place des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre :
          </p>
          <ul>
            <li>L'accès non autorisé</li>
            <li>La divulgation</li>
            <li>La modification</li>
            <li>La destruction</li>
          </ul>

          <h2>10. Réclamations</h2>
          <p>
            Si vous estimez que le traitement de vos données ne respecte pas la réglementation, 
            vous pouvez introduire une réclamation auprès de l'Autorité de protection des données (APD) : 
            <a href="https://www.autoriteprotectiondonnees.be" target="_blank" rel="noopener noreferrer">
              www.autoriteprotectiondonnees.be
            </a>
          </p>

          <h2>11. Contact</h2>
          <p>
            Pour toute question concernant cette politique de confidentialité :
          </p>
          <p>
            <strong>Château de Clémentine</strong><br />
            Avenue de la Rosée 12<br />
            1640 Rhode-Saint-Genèse<br />
            Email : lechateaudeclementine@gmail.com<br />
            Téléphone : +32-123-45-67-89
          </p>

          <h2>12. Modifications</h2>
          <p>
            Cette politique de confidentialité peut être modifiée. 
            La version la plus récente est toujours disponible sur cette page avec la date de dernière mise à jour.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;